var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"width":_vm.width,"height":_vm.height,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }